import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { filledToggleGroupSx } from "@shared";

import { ExchangeView } from "@/pages/exchange/Exchange.types";
import { useTranslation } from "@/translations";

interface Props {
  value: ExchangeView;
  onChange: (value: ExchangeView) => void;
}

export function ExchangeViewToggle({ value, onChange }: Props) {
  const { t } = useTranslation();

  return (
    <ToggleButtonGroup
      exclusive
      value={value}
      aria-label={t("exchange.view.toggleAriaLabel")}
      onChange={(_event, next: ExchangeView | null) => {
        if (next !== null) {
          onChange(next);
        }
      }}
      sx={filledToggleGroupSx}
    >
      <ToggleButton value="others" sx={{ minWidth: 90 }}>
        {t("exchange.view.others")}
      </ToggleButton>
      <ToggleButton value="mine" sx={{ minWidth: 90 }}>
        {t("exchange.view.mine")}
      </ToggleButton>
    </ToggleButtonGroup>
  );
}
